import React, { useState, useEffect } from "react";
import { BsHeart } from "react-icons/bs";
import { MdAccountCircle } from 'react-icons/md';
import { db } from '../firebase';


function Post({ postId, username, user, caption, imageUrl }) {
  const [comments, setComments] = useState([]);
  const [comment, setComment] = useState('');

        useEffect(() => {
          let unsubscribe;

          if (postId) {
              unsubscribe = db
              .collection("posts")
              .doc(postId)
              .collection("comments")
              .onSnapshot((snapshot) => {
                setComments(snapshot.docs.map((doc) => doc.data()));
        });
      }

      return () => {
        unsubscribe();
      };
    }, [postId]);

    const postComment = (event) => {
      event.preventDefault();
      db.collection("posts").doc(postId).collection("comments").add({
        text: comment,
        username: user.displayName,
      });
      setComment('');
    }

    return (

      <div className="container d-flex justify-content-center mt-3">
        <div className="card card-posts shadow-sm">
    <div className="card-header d-flex align-items-center">
      
      <h6 className="d-flex align-items-center mr-auto"><MdAccountCircle size={32} className="mr-3"/><strong>{username}</strong></h6>
      <div className="d-flex">
                <button className="btn"><BsHeart size={22}/></button>
                </div>
      </div>
          <img src={imageUrl} className="card-img rounded-0" alt="post-img"/>
          <div className="container mt-2">
            <div className="icons d-flex align-items-center">
              
            </div>
            <div className='d-flex mt-3 border-bottom pb-2'>
              <p className="card-text mr-2">
                <strong>{username}</strong> {caption}
                </p>
            </div>

            {
              <div className="mt-2">
                {comments.map((comment) => (
                  <p><strong>{comment.username}</strong> {comment.text}</p>
                ))}
            </div>
            }


            <form className="form-group d-flex p-2">
                  <input 
                  className="form-control mr-2"
                  type="text"
                  placeholder="Add comment..."
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  />

                  <button
                  className="btn btn-dark"
                  disabled={!comment}
                  type="submit"
                  onClick={postComment}
                  >
                    Send
                  </button>
                </form>
          </div>
        </div>
      </div>
    );
  }

export default Post;
